import qs from 'qs';
import { ConfigurationServiceConfig } from '../../types/ServiceConfigurations';
import { CountryResponse } from '../../types/Country';
import {
  ConfigurationResponseData,
  IConfigurationService,
} from '../../types/Configuration';
import { Endpoints } from '../../utils/constants';
import { LoginPostParameters } from '../RequestParameters';
import ServiceError from '../../models/classes/ServiceError';

const ApiError = new ServiceError(
  'ConfigurationService',
  'error contacting API'
);

class ConfigurationService implements IConfigurationService {
  private storeUrl: string;

  constructor(config: ConfigurationServiceConfig) {
    this.storeUrl = config.apiUrl;
  }

  // TODO - Once TP-425 is re-instated, validation will be required

  public async getConfigAsync(): Promise<ConfigurationResponseData | null> {
    try {
      const response = await window.fetch(`${this.storeUrl}/api/v1/config`, {
        credentials: 'include',
      });
      if (response.status === 401) {
        return null;
      }

      const responseJson = await response.json();
      return responseJson.data ?? null;
    } catch (error) {
      // TODO: Error trace/logging
      // eslint-disable-next-line no-console
      console.error(error);
      return null;
    }
  }

  public async getCountryConfigAsync(): Promise<CountryResponse[] | null> {
    try {
      const response = await window.fetch(`${this.storeUrl}/api/v1/countries`, {
        credentials: 'include',
      });
      const responseJson = await response.json();
      return responseJson.data ?? null;
    } catch (error) {
      // TODO: Error trace/logging
      // eslint-disable-next-line no-console
      console.error(error);
      return null;
    }
  }

  public async verifyReCaptchaAsync(reCaptchaValue: string): Promise<number> {
    try {
      const response = await fetch(`${this.storeUrl}${Endpoints.RECAPTCHA}`, {
        ...LoginPostParameters,
        body: qs.stringify({
          'g-recaptcha-response': reCaptchaValue,
        }),
      });
      if (response?.status !== 200) {
        return 400;
      }
      return 200;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      throw ApiError;
    }
  }
}

export default ConfigurationService;
